import { render, staticRenderFns } from "./Togglepanelexercise.vue?vue&type=template&id=789e559f&"
import script from "./Togglepanelexercise.vue?vue&type=script&lang=js&"
export * from "./Togglepanelexercise.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports